<template >
  <div>
    <div class="panelBarClass">
      <kendo-tabstrip class="m-3">
       <ul>
        <li class="k-state-active">ReportMaster</li>
       </ul>
       <div class="overflow-hidden"> 
      <form ref="form" class="" v-kendo-validator @submit.prevent="addReportData()">
          <div class="page-header d-flex w-100 bg-white driver_header_mobile">
            <div class="title-col d-flex w-50  mobile_side_lbl">
             <span class="title-icon">
              <b-icon-folder-fill></b-icon-folder-fill>
             </span>
             <span class="title-text" v-if="add">Add ReportMaster</span>
             <span class="title-text" v-else>Update ReportMaster</span>
            </div>
            <div class="text-right ml-auto mobile_side_btn">
              <button class="k-button k-green ml-2" v-if="add">Add</button>
              <button class="k-button k-primary ml-2" v-if="!add">Update</button>
              <button class="k-button k-gray ml-2" @click="goToListPage">Cancel</button>
             </div>
          </div>
          <kendo-panelbar id="panelbar" class="">
            <div id="item1">
              Basic Information
              <div class="">
                <div class="bg-white">
                  <div class="k-form form-class">
                    
                    <div class="row">
                      <div class="col-6 col-md-3 col-sm-3 col-lg-3 form-group">
                          <label>Name<span style="color: red;">*</span></label>
                          <k-input name="Name" :style="{ width:'100%' }" :required="true"
                           id="name" v-model="name" />
                      </div>
                     
                      <div class="col-6 col-md-3 col-sm-3 col-lg-3 form-group">
                          <label>Description<span style="color: red;">*</span></label>
                          <textarea cols="30" class="form-control" rows="1" name="description"
                           :style="{ width:'100%' }" :required="true" id="description"
                             v-model="description">
                          </textarea>
                          
                      </div>
                      <div class="col-6 col-md-3 col-sm-3 col-lg-3 form-group">
                           <label>ReportTitle<span style="color: red;">*</span></label>
                           <k-input name="ReportTitle" :style="{ width:'100%' }" :required="true"
                           id="reportTitle" v-model="reportTitle" />
                      </div>
                    </div>
                    <div class="row">
                         <div class="col-6 col-md-3 col-sm-3 col-lg-3 form-group">
                          <label>Report GroupID<span style="color: red;">*</span></label>
                          <dropdownlist class="w-100" v-model="reportGroupID" :style="{  width: '100%' }"
                          :data-items="getGroupTypes" :data-item-key="'id'" :text-field="'name'"
                          :placeholder="'Select Group'" :name="'Visible'" :required="true">
                          </dropdownlist>
                      </div>
                    
                      <div class="col-6 col-md-3 col-sm-3 col-lg-3 form-group">
                          <label>Parent ReportId</label>
                          <dropdownlist class="w-100" v-model="parentReportID" :style="{  width: '100%' }"
                          :data-items="getParentGroupTypes.filter((v) =>
                    v.name.toLowerCase().includes(this.filterchangeTeam)
                  )
                " :data-item-key="'id'" :text-field="'name'"
                          :name="'Visible'" :required="true" :filterable="true" @filterchange="filterChange">
                           </dropdownlist>
                      </div>
                      
                    </div>
                    <div class="row">
                      <!-- <div class="col-6 col-md-3 col-sm-3 col-lg-3 form-group">
                          <label>Tenant<span style="color: red;">*</span></label>
                          <dropdownlist class="w-100" v-model="tenantTypeId" :style="{  width: '100%' }"
                           :data-items="getCommonTenantTypes" :data-item-key="'id'" :text-field="'name'"
                           :name="'tenantType'">
                           </dropdownlist>
                      </div> -->
                     
                      <div class="col-6 col-md-3 col-sm-3 col-lg-3 form-group">
                        <label>Client Specific</label>
                        <kendo-switch name="switch"  v-model="isClientSpecific"></kendo-switch>
                      </div>
                      <!-- <div class="col-6 col-md-3 col-sm-3 col-lg-3 form-group">
                        <label>IsVisible</label>
                        <kendo-switch name="switch"  v-model="isVisible"></kendo-switch>
                      </div> -->
                      
                     
                    </div>
                <div class="row">
                  <div class="col-18 col-md-9 col-sm-9 col-lg-9 form-group">
                            <label>Configuration<span style="color: red;">*</span></label>
                            <textarea cols="30" class="form-control" rows="5" name="Configuration"
                            :style="{ width:'100%' }" :required="true" id="configuration"
                            v-model="configuration">
                            </textarea>
                      </div>
                </div>
                  </div>
                </div>
              </div>
          </div>
        </kendo-panelbar>
       </form>
    </div> 
    <div class="pt-3">
      <FileUpload />
    </div>
  </kendo-tabstrip>
 </div>
</div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("reportMaster");
import { notifyWarn, notify, notifyError, notifyApiError } from '@/utils/notification-helper';
import { MESSAGES } from "@/utils/constants";

export default {
  data: function () {
    return {
      add: this.$route.params.add,
      reportMasterData: {},
      expand: true,
      name: null,
      description: null,
      configuration: null,
      isClientSpecific: false,
      isVisible:true,
      reportTitle:null,
      reportGroupID:null,
      parentReportID:null,
      redirectUrl:null,
      tenantTypeId: null,
      deviceType:null,
      id:null,
      filterchangeTeam:''
      

    }
},
methods: {
  filterChange(e) {
      this.filterchangeTeam = e.filter.value
        ? e.filter.value.toLowerCase()
        : "";
    },
  
  expandPanel() {
      let header = document.querySelectorAll("#panelbar .k-header");
      let element = document.querySelectorAll("#panelbar .k-content")[0];
      element.setAttribute("style", "display:block !important");
      header[0].addEventListener("click", () => {
        if (element.getAttribute("style") == "display: block;") {
          element.setAttribute("style", "display:none !important");
        }
      });
    },
    goToListPage: function () {
      this.$router.push({ name: "reportMaster" });
    },

    async getDataOnload() {
      if (!this.$route.params.add) {
        this.deviceEditData = this.$store.getters["reportMaster/getEditReport"];
        this.name= this.deviceEditData.name
        this.description= this.deviceEditData.description
        this.configuration= this.deviceEditData.configuration
        this.isClientSpecific= this.deviceEditData.isClientSpecific 
        this.isVisible= this.deviceEditData.isVisible
        this.reportTitle= this.deviceEditData.reportTitle
        this.reportGroupID= this.initialData.reportGroups.find(rep => rep.id === this.deviceEditData.reportGroupID)
        this.parentReportID=this.ParentGroupIdData.find(rep => rep.id === this.deviceEditData.parentReportID)     
       }
    },
    addReportData() {
          this.reportMasterData= {
            Name:this.name,
            Description:this.description,
            Configuration:this.configuration,
            IsClientSpecific: this.isClientSpecific,
            IsVisible:this.isVisible,
            ReportTitle:this.reportTitle,
            ReportGroupId: this.reportGroupID.id,
            ParentReportId:this.parentReportID ? this.parentReportID.id : this.parentReportID
          // RedirectUrl:this.redirectUrl,
          };
          if (this.add) {
            this.$store
            .dispatch("reportMaster/addReportMaster", this.reportMasterData)
            .then((data) => {
              if (data.status) {
                notify(MESSAGES.RECORD_CREATE_SUCCESS);
                this.goToListPage();
                this.clearEntries();
              } else {
                notifyWarn(data.message);
              }
            })
            .catch((err) => {
              try {
                notifyError(err.response.data.message);
              } catch (error) {
                notifyApiError({ message: "Something went wrong" });
              }
            });
          }
          else {
          this.$store.dispatch("reportMaster/updateReportMaster", this.reportMasterData)
            .then((data) => {
                if(data.status) {
                    notify(MESSAGES.CHANGES_SAVE_SUCCESS);
                    this.goToListPage();
                    this.clearEntries();
                } else {
                    notifyWarn(data.message);
                }
            })
            .catch(notifyApiError);
            // .then(() => {
            //   notify(MESSAGES.CHANGES_SAVE_SUCCESS);
            //   this.goToListPage();
            //   this.clearEntries();
            // })
            // .catch(notifyApiError);
           
          }
        
        
      },
    
    clearEntries: function () {
      this.name= null,
      this.description= null,
      this.configuration= null,
      this.isClientSpecific= false,
      this.isVisible=true,
      this.reportTitle=null,
      this.reportGroupID=null,
      this.ParentReportID =null
    },
   
  },
computed:{
  ...mapState(["initialData","ParentGroupIdData"]),
  getGroupTypes() {
      return this.initialData.reportGroups;
  },
 
  getParentGroupTypes(){
   let newArray = this.deviceEditData ? this.ParentGroupIdData.filter((report)=>report.id !== this.deviceEditData.id):this.ParentGroupIdData
   return newArray;

  },
  getCommonTenantTypes() {
    return this.initialData.tenants
 }
},
beforeMount(){
    this.getDataOnload();
},
 mounted() {
    this.expandPanel();
  },
 
    
}
</script>
<style lang="">
    
</style>